module.exports = __webpack_public_path__ + "img/otimes.944170b8.png";